<template>
  <div class="check-work-body">

    <div class="">
      <department-tree @node-click="nodeClick"></department-tree>
    </div>


    <div class="check-work-right">

      <!-- 搜索 -->
      <div class="search-wrap">
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="getDepartmentMember()" :loading="searchLoading">搜索</el-button>
      </div>

      <!-- 管理员列表 -->
      <div class="table-wrap">
        <el-table v-loading="searchLoading" :data="tableData">
          <el-table-column prop="columns.UserName" label="姓名" align="center"></el-table-column>
          <el-table-column label="性别" align="center">
            <template slot-scope="scope">
              {{getSexText(scope.row.columns.sex)}}
            </template>
          </el-table-column>
          <el-table-column prop="columns.MobilePhone" label="手机" align="center"></el-table-column>
          <el-table-column prop="columns.BankDeposit" label="开户行" align="center"></el-table-column>
          <el-table-column prop="columns.BankCode" label="卡号" align="center"></el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-tickets" @click="showDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div>


    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加管理员" :visible.sync="dialogVisible" :close-on-click-modal="true" width="650px">

      <table class="check-work-tb" style="width: 100%; margin-top: 10px;">
        <tr>
          <th width="100">姓名</th>
          <td>{{userInfo.UserName}}</td>
        </tr>
        <tr>
          <th width="100">电话</th>
          <td>{{userInfo.MobilePhone}}</td>
        </tr>
        <tr>
          <th width="100">部门</th>
          <td>{{userInfo.DepartmentName_Auto}}</td>
        </tr>
        <tr>
          <th width="100">开户行</th>
          <td>{{userInfo.BankDeposit}}</td>
        </tr>
        <tr>
          <th width="100">开户城市</th>
          <td>{{userInfo.bank_address}}</td>
        </tr>
        <tr>
          <th width="100">卡号</th>
          <td>{{userInfo.BankCode}}</td>
        </tr>
        <tr>
          <th width="100">身份证号</th>
          <td>{{userInfo.PostTitle}}</td>
        </tr>
        <tr>
          <th width="100">地址</th>
          <td>{{userInfo.NowPlaceAddress}}</td>
        </tr>
        <tr>
          <th width="100">出生日期</th>
          <td>{{DateFormat(userInfo.Birthday)}}</td>
        </tr>
        <tr>
          <th width="100">转正日期</th>
          <td>{{DateFormat(userInfo.BeginWorkDate)}}</td>
        </tr>
        <tr>
          <th width="100">紧急联系人</th>
          <td>{{userInfo.UrgencyContractPer}} - {{userInfo.UrgencyContractPhone}}</td>
        </tr>
        <tr>
          <th width="100">身份证正反面</th>
          <td>
            <a target="_blank" :href="userInfo.idcard_front_img" v-if="userInfo.idcard_front_img"><img :src="userInfo.idcard_front_img" height="100" /></a>
            <a target="_blank" :href="userInfo.idcard_back_img" v-if="userInfo.idcard_back_img"><img :src="userInfo.idcard_back_img" height="100" /></a>
          </td>
        </tr>
        <tr>
          <th width="100">银行卡正反面</th>
          <td>
            <a target="_blank" :href="userInfo.bank_front_img" v-if="userInfo.bank_front_img"><img :src="userInfo.bank_front_img" height="100" /></a>
            <a target="_blank" :href="userInfo.bank_back_img" v-if="userInfo.bank_back_img"><img :src="userInfo.bank_back_img" height="100" /></a>
          </td>
        </tr>
        
        <tr>
          <th width="100">合同</th>
          <td>
            <a target="_blank" :href="item" v-for="item in userInfo.contract_img" style="margin-right: 5px;"><img :src="item" height="100" /></a>
          </td>
        </tr>
      </table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import { Admin, User, UserManage, DateFormat } from './common.js'
  import DepartmentTree from "./department-tree.vue";

export default {
  name: "UserManage",
  components: {DepartmentTree},
  data() {
    return{
      keyword: '',
      dialogVisible: false,
      departmentId: '',
      departmentList: [],
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 20,
      searchLoading: false,
      userInfo: {}
    }
  },
  mounted() {

    UserManage.getUserDepartment({}, res => {
      if(res.code == 0) {
        this.departmentList = res.data
      }
    })

  },
  methods:{

    getDepartmentMember() {

      UserManage.getDepartmentMember({department_id: this.departmentId, keyword: this.keyword, page: this.page}, res => {
        if(res.code == 0) {
          this.tableData = res.data.list.map(item => {

            if(item.columns.contract_img) {
              item.columns.contract_img = item.columns.contract_img.split(',').map(path => {
                return 'https://zoa.51homemoney.com:8444/' + path
              })
            } else {
              item.columns.contract_img = []
            }

            return item

          })
          this.total = res.data.totalRow
        } else {
          this.$message.error(res.msg)
        }
      })

    },

    nodeClick(data) {
      this.departmentId = data.data.departmentID
      this.getDepartmentMember()
    },

    pageChange(data) {

        console.log(data)
    },

    getSexText: User.getSexText,

    DateFormat(val) {

      if(val) {
        return DateFormat(new Date(val))
      }

      return ''

    },

    showDetail(item) {

      console.log(item.columns)

      this.userInfo = item.columns
      this.dialogVisible = true
    }

    // end methods
  }
}
</script>

<style lang="scss" scoped>
  @import './common.scss';

  .check-work-body {
    display: flex;
  }

  .check-work-right {
    margin-left: 10px;
    flex: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/UserManage.vue